import type { TableRowData } from '@/ui/components/TeamsTable/TeamsTable.types';

import type { PrematchTableRow } from '../types';

export function mapTableRowsToRowData(rows: PrematchTableRow[]): TableRowData[] {
  return rows.map((row) => {
    const base = {
      position: row.no,
      color: row.color,
      points: row.points,
      teamName: row.teamName,
      playedMatches: row.playedMatches,
      wins: row.wins,
      draws: row.draws,
      losses: row.losses,
      form: [...row.form].reverse(),
      isHighlighted: row.inPlay,
    };

    if (row.jersey) {
      return {
        ...base,
        jerseySrc: row.jersey,
      } satisfies TableRowData;
    }

    return {
      ...base,
      ...(row.flag ? { teamImageUrl: row.flag } : {}),
    } satisfies TableRowData;
  });
}
